import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { CDSMask } from '@app/utils/cds-mask';

import { Conta } from '@app/models/conta.model';
import { IdDescricao } from '@app/models/util/id-descricao';

import { ContaService } from '@app/services/conta.service';
import { ConsultasService } from '@app/services/consultas.service';

@Component({
  selector: 'app-conta-form',
  templateUrl: './conta-form.component.html'
})
export class ContaFormComponent implements OnInit {

  aguardandoSolicitacao : boolean = false;
  conta: Conta = new Conta();
  titulo: string;
  lstErros: string[];

  lstBanco: IdDescricao[];
  lstUnidade: IdDescricao[];
  cdsMask = new CDSMask();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private contaService: ContaService,
    private consultasService: ConsultasService,
  ) { }

  ngOnInit() {
    this.consultasService.consultar('BANCO').toPromise().then(data => this.lstBanco = data);
    this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidade = data);
    this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Conta' : 'Nova Conta';

      if (!id) {
        return;
      }
      this.contaService.obterPorId(id).toPromise().then(
        data => this.conta = data,
        () => this.router.navigate(['./configuracoes/conta']));
    });
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.contaService.gravar(this.conta).toPromise().then(
      () => this.router.navigate(['./configuracoes/conta']),
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      });
  }
}
